<template>
	<van-popup v-model="show" :position="isMobileFlag?'bottom':'center'" get-container="body" closeable class="bs-popup">
		<div class="bs-popup-head">
			<div class="bs-popup-tit">{{$t('代理说明')}}</div>
		</div>
		<div class="bs-popup-scroll">
			<div class="bs-popup-body " >
				<div class="tip-content" v-html="pageData.content">
				</div>
			</div>
		</div>
	</van-popup>
	
</template>
<script>
	import {index_notice_details_api,index_notice_list_api} from '@/api/index'
	export default {
		components: {},
		props: {
			pageid: {
			    type: Number,
			    default: 0
			  }
		},
		data() {
			return {
				show: false,
				pageData:""
			};
		},
		methods:{
			async getNotice(pageid) {
				let param = {
					id: pageid,
				};
			  const res = await index_notice_details_api(param);
			  if (res && res.data.code == 1) {
				this.pageData = res.data.data
			  }
			},
			async getAll() {
				let param = {};
				this.$helper.rm("topNavs");
				const res = await index_notice_list_api(param);
				if (res && res.data.code == 1) {
					this.$helper.set("topNavs", res.data.data);
					const navOne = this.$helper.get('topNavs').filter(item => item.is_nav === 2);
					this.getNotice(navOne[1].id)
				}
			}
		},
		mounted() {
			this.getAll()
		}
	}
</script>